import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor() { }

  // metodo per ottenere un dato dal localstorage
  // NB, facciamo sempre il parsing che alla fine ci serve sempre
  getFromLocalStorage(key: string): any {
    const value = localStorage.getItem(key);
    return this.parseJSON(value);
  }

  // Metodo per ottenere un dato dal sessionStorage
  // NB, facciamo sempre il parsing che alla fine ci serve sempre
  getFromSessionStorage(key: string): any {
    const value = sessionStorage.getItem(key);
    return this.parseJSON(value);
  }

  // Funzione per il recupero dei dati dall'uno o dall'altro 
  getFromLocalOrSessionStorage(key: string): any {
    return this.getFromLocalStorage(key) || this.getFromSessionStorage(key)
  }

  private parseJSON(value: string | null): any {
    if (value) {
      try {
        return JSON.parse(value);
      } catch (error) {
        console.error('Errore nel parsing del JSON', error);
        return null;
      }
    }
    return null;
  }

  clearStorage() {
    localStorage.clear();
    sessionStorage.clear();
  }
}